import { ALTERAR_DETALHAMENTO_PEDIDO } from '../types'

export default function alterarExibicaoDetalhamentoPedido (pedido) {
  return {
    type: ALTERAR_DETALHAMENTO_PEDIDO,
    payload: pedido
  }
}
